import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
const deliverables = [{
  title: 'The Wearable Fix Main Protocol',
  desc: 'The master system to move from Red to Green readiness in 7 days.'
}, {
  title: 'The Thermal Dump Method',
  desc: 'The #1 hack to force your brain into Deep Sleep stages within 90 minutes.'
}, {
  title: 'The Sunlight Anchor',
  desc: "How to set your biological clock so your 'Sleep Gate' opens exactly when you want it to."
}, {
  title: 'The Bio-Data Translator',
  desc: 'Learn to read the hidden signals in your HRV and Sleep Latency graphs.'
}];
const bonuses = ["The 'Wake Up In Red' SOS Checklist.", "The 2026 Biohacker's Supplement Tier-List.", 'The Travel & Jet Lag Blueprint.'];
export function WhatYouGet() {
  return <section className="py-24 bg-brand-dark border-y border-brand-panelBorder" data-id="element-203">
      <div className="max-w-5xl mx-auto px-6" data-id="element-204">
        <div className="text-center mb-16" data-id="element-205">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4" data-id="element-206">What You Get</h2>
          <p className="text-brand-gray text-lg" data-id="element-207">
            Everything you need to master your recovery data.
          </p>
        </div>

        <div className="grid lg:grid-cols-5 gap-8" data-id="element-208">
          <div className="lg:col-span-3 space-y-4" data-id="element-209">
            {deliverables.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-brand-panel border border-brand-panelBorder rounded-2xl p-6 flex gap-4" data-id="element-210">
                <CheckCircle2 className="w-6 h-6 text-brand-green shrink-0 mt-1" data-id="element-211" />
                <div data-id="element-212">
                  <h3 className="text-lg font-bold mb-1" data-id="element-213">{item.title}</h3>
                  <p className="text-brand-gray" data-id="element-214">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>

          <div className="lg:col-span-2" data-id="element-215">
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a] border border-brand-green/30 rounded-2xl p-8 h-full relative overflow-hidden" data-id="element-216">
              <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-217">
                <Gift className="w-32 h-32 text-brand-green" data-id="element-218" />
              </div>

              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-green/20 text-brand-green text-sm font-bold mb-6" data-id="element-219">
                <Gift className="w-4 h-4" data-id="element-220" />
                INCLUDED BONUSES
              </div>

              <ul className="space-y-6 relative z-10" data-id="element-221">
                {bonuses.map((bonus, index) => <li key={index} className="flex gap-3 items-start" data-id="element-222">
                    <div className="w-6 h-6 rounded-full bg-brand-green/20 flex items-center justify-center shrink-0 mt-0.5" data-id="element-223">
                      <span className="text-brand-green text-xs font-bold" data-id="element-224">
                        {index + 1}
                      </span>
                    </div>
                    <span className="font-medium text-white/90" data-id="element-225">{bonus}</span>
                  </li>)}
              </ul>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}